import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Menu, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { IChecklistQuestionType } from "../../interfaces/CheckLists";
import { useLocale } from "../../providers/LocaleProvider";
import { Button } from "../Button";

interface QuestionTypeSelectorProps {
  qIndex: number;
  onChangeType: (questionIndex: number, prevTypeId: string, nextTypeId: string) => void;
  listQuestionTypes?: IChecklistQuestionType[];
  name: string;
}

export default function QuestionTypeSelector({
  qIndex,
  onChangeType,
  listQuestionTypes,
  name
}: QuestionTypeSelectorProps) {
  const { translate } = useLocale();
  const { setValue, getValues, control } = useFormContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  useEffect(() => {
    const current = getValues(`${name}.checklistQuestionTypeId`);
    if (!current && listQuestionTypes?.length) {
      setValue(`${name}.checklistQuestionTypeId`, listQuestionTypes[0].id, {
        shouldDirty: false,
        shouldTouch: false,
        shouldValidate: false
      });
    }
  }, [listQuestionTypes, name, setValue, getValues]);

  return (
    <Controller
      control={control}
      name={`${name}.checklistQuestionTypeId`}
      render={({ field }) => (
        <>
          <Button
            size='md'
            variant='outlined'
            label={
              listQuestionTypes?.find((i: IChecklistQuestionType) => i.id === field.value)?.name ||
              translate("common.type")
            }
            endIcon={<KeyboardArrowDownIcon />}
            type='button'
            onClick={handleOpen}
          />
          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            {listQuestionTypes?.map((i: IChecklistQuestionType) => (
              <MenuItem
                key={i.id}
                onClick={() => {
                  const prevTypeId = field.value;
                  field.onChange(i.id);
                  onChangeType?.(qIndex, prevTypeId, i.id);
                  handleClose();
                }}
              >
                {i.name}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    />
  );
}
